import React, {useRef, useState, useCallback} from "react";
import {debounce} from 'throttle-debounce';
import OptionMember from "./SelectOptions/OptionMember";
import Icons from "../../Icons";

const UISelectSearch = ({
    name,
    value,
    defaultOptionTitle,
    options,
    required,
    labelClassName,
    label,
    error,
    errorName,
    onChange,
    isOptionsDisabled,
    noOptionsMessage,
    placeholder,
    $locale,
    props,
    optionCancel,
    OptionComponent = OptionMember,
}) => {
    const selectRef = useRef(null);
    const toggleSelectRef = useRef(null);
    const [isShowSelect, setIsShowSelect] = useState(false);
    const [searchOptions, setSearchOptions] = useState(options);
    const className = "ui-select-search";

    const closeSelect = () => {
        document.removeEventListener('mousedown', handleClickOutsideSelect);
        setIsShowSelect(false);
    }

    const handleClickOutsideSelect = (event) => {
        const isTouchSelect = selectRef.current && selectRef.current.contains(event.target);
        const isTouchToggleSelect = toggleSelectRef.current && toggleSelectRef.current.contains(event.target);
        if (!isTouchSelect && !isTouchToggleSelect) {
            closeSelect();
        }
    };

    const showSelectToggle = () => {
        if (isOptionsDisabled) {
            return;
        }

        if (!isShowSelect) {
            document.addEventListener('mousedown', handleClickOutsideSelect);

            let selectOptions = options;
            if (optionCancel) {
                selectOptions = [optionCancel].concat(selectOptions);
            }

            setSearchOptions(selectOptions);
            setIsShowSelect(true);
        } else {
            closeSelect();
        }
    }

    const onChangeInput = useCallback(debounce(300, (search) => {
        if (!search && optionCancel) {
            setSearchOptions([optionCancel].concat(options));
        } else {
            setSearchOptions(options.filter((option) => option.label.toLowerCase().includes(search.toLowerCase())));
        }
    }), [options]);

    const onChangeOption = (value) => {
        onChange(value);
        closeSelect();
    }

    return (
        <div className="ui-input-component ui-select">
            {!!label && (
                <label
                    htmlFor={name}
                    className={labelClassName}
                >
                    {label}
                </label>
            )}
            {error && errorName && 
                <label className="input-error">{errorName}</label>
            }
            {error && typeof error !== 'boolean' &&
                <label className="input-error">{error}</label>
            }
            <div className={`ui-select-container ${error ? 'input-error' : ''}`}>
                <div
                    className={`${className}--toggle ${isOptionsDisabled ? '-is-disabled' : ''}`}
                    ref={toggleSelectRef}
                    onClick={showSelectToggle}
                >
                    <div className={`${className}--current-value`}>{value ? value.label : defaultOptionTitle}</div>
                    {!isOptionsDisabled && (
                        <svg className="select-button" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16" fill="none">
                            <path d="M7.1343 9.83325C7.5192 10.4999 8.48145 10.4999 8.86635 9.83325L10.0211 7.83325C10.406 7.16659 9.92483 6.33325 9.15503 6.33325H6.84563C6.07583 6.33325 5.5947 7.16658 5.9796 7.83325L7.1343 9.83325Z" fill="white"/>
                        </svg>
                    )}
                </div>
                {isShowSelect && (
                    <div className={`${className}--select-container`} ref={selectRef}>
                        <div className={`${className}--search-container`}>
                            <Icons name="search" />
                            <input
                                name={name}
                                placeholder={placeholder}
                                onInput={(e) => onChangeInput(e.target.value)}
                                required={required}
                                className={`${className}--search-container--search`}
                                {...props}
                            />
                        </div>

                        <div className={`${className}--list scrollable`}>
                            {searchOptions.map((value) => (
                                <OptionComponent key={value.value} value={value} onChange={onChangeOption} $locale={$locale} />
                            ))}

                            {searchOptions.length < 1 && (
                                <div className={`${className}--no-options`}>{noOptionsMessage}</div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UISelectSearch;
